import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBellRinging = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Icons / 16px / BellRinging",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M3.51269 7.0002C3.51269 6.41089 3.62876 5.82735 3.85428 5.2829C4.0798 4.73845 4.41035 4.24376 4.82705 3.82705C5.24375 3.41035 5.73845 3.0798 6.2829 2.85429C6.82735 2.62877 7.41089 2.5127 8.00019 2.5127C8.5895 2.5127 9.17304 2.62877 9.71748 2.85429C10.2619 3.0798 10.7566 3.41035 11.1733 3.82705C11.59 4.24376 11.9206 4.73845 12.1461 5.2829C12.3716 5.82735 12.4877 6.41089 12.4877 7.0002V7.0002C12.4877 9.2377 12.9564 10.5377 13.3689 11.2502C13.4128 11.3261 13.4359 11.4121 13.4359 11.4998C13.436 11.5874 13.4131 11.6735 13.3694 11.7494C13.3257 11.8254 13.2628 11.8885 13.1871 11.9325C13.1113 11.9766 13.0253 11.9999 12.9377 12.0002H3.06269C2.97507 11.9999 2.88907 11.9766 2.81331 11.9325C2.73754 11.8885 2.67468 11.8254 2.631 11.7494C2.58732 11.6735 2.56438 11.5874 2.56445 11.4998C2.56453 11.4121 2.58763 11.3261 2.63144 11.2502C3.04394 10.5377 3.51269 9.2377 3.51269 7.0002Z",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M6 12V12.5C6 13.0304 6.21071 13.5391 6.58579 13.9142C6.96086 14.2893 7.46957 14.5 8 14.5C8.53043 14.5 9.03914 14.2893 9.41421 13.9142C9.78929 13.5391 10 13.0304 10 12.5V12",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M11.4629 1.5C12.4809 2.14263 13.3026 3.05292 13.8379 4.13125",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M2.16211 4.13125C2.69744 3.05292 3.51908 2.14263 4.53711 1.5",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgBellRinging;
